import Vue from 'vue'
import VueRouter from 'vue-router'
import * as miFn from "../utils/mi";

import * as mi2 from "../utils/mi2";
//引入jsonp请求方法
const jsonp = require("jsonp");

Vue.use(VueRouter)

const routes = [{
	path: '/',
	name: 'Index',
	component: () => import( /* webpackChunkName: "about" */ '../views/index/index.vue')
},
{
	path: '/home',
	name: 'Home',
	component: () => import( /* webpackChunkName: "about" */ '../views/home/Home.vue')
},
{
	path: '/draw',
	name: 'Draw',
	component: () => import( /* webpackChunkName: "about" */ '../views/draw/draw.vue')
},
{
	path: '/luckdraw',
	name: 'Luckdraw',
	component: () => import( /* webpackChunkName: "about" */ '../views/box/box.vue')
},
{
	path: '/winning',
	name: 'Winning',
	component: () => import( /* webpackChunkName: "about" */ '../views/winningList/winning.vue')
},
{
	path: '/blindDetails',
	name: 'BlindDetails',
	component: () => import( /* webpackChunkName: "about" */ '../views/blindDetails/index.vue')
},
{
	path: '*',
	redirect:"/"
}
]

const router = new VueRouter({
	mode: 'hash',
	base: "",
	routes
})
// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject)
		return originalPush.call(this, location, onResolve, onReject);
	return originalPush.call(this, location).catch((err) => err);
};


var publicUrl = "https://s1.mi.com/m/partner/2021/0113necel"
var search=location.search;
// if(location.protocol=="http:"){
// 	window.location.href=publicUrl;
// }
if(search==""||search==null||search==undefined){
	
}else{
	var url = location.origin + location.pathname+'#' +location.search + location.hash;
	window.location.href=url;
}
router.beforeEach((to, from, next) => {
	// 在页面加载时读取sessionStorage里的状态信息
	if (mi2.platform.isApp || mi2.platform.isIOSApp) {
		const shareData = {
			//web链接分享
			h5_v3: {
				//微博按钮
				//图片比例不限
				weibo: {
					content: "小米邀你免费抽盲盒",
					img_url: `${publicUrl}/img/role2.jpg?djkd`,
					share_url: publicUrl,
				},
				//微信好友按钮(优先级低于小程序分享)
				//图片比例120*120
				wechat_friend: {
					title: "小米邀你免费抽盲盒",
					content: "小米@你，开新年盲盒领隐藏惊喜。",
					img_url: `${publicUrl}/img/role2.jpg?djkd`,
					share_url: publicUrl,
				},
				//微信朋友圈按钮(优先级低于小程序分享)
				//图片比例120*120
				wechat_moments: {
					title: "小米@你，开新年盲盒领隐藏惊喜。",
					img_url: `${publicUrl}/img/role2.jpg?djkd`,
					share_url: publicUrl,
				},
				//qq好友按钮
				//图片比例120*120
				qq_friend: {
					title: "小米邀你免费抽盲盒",
					content: "小米@你，开新年盲盒领隐藏惊喜。",
					img_url: `${publicUrl}/img/role2.jpg?djkd`,
					share_url: publicUrl,
				},
				//qq朋友圈按钮
				//图片比例120*120
				qq_moments: {
					title: "小米邀你免费抽盲盒",
					content: "小米@你，开新年盲盒领隐藏惊喜。",
					img_url: `${publicUrl}/img/role2.jpg?djkd`,
					share_url: publicUrl,
				},
				//复制链接按钮的网址
				share_url: publicUrl,
			},
		};
		mi2.shareInitApp(shareData);
	} else {
		getShareMsg();
	}
	window.scrollTo(0, 0);
	if (window.location.hostname == "s1.mi.com") {
		if (to.path != '/') {
			if (!miFn.isLogin()) {
				localStorage.setItem("userLogin", "yes")
				miFn.doLogin()
			} else {
				next()
			}
		} else {
			next()
		}
	} else {
		next()
	}
})

function getShareMsg() {
	let doFunc = 'sdk_signature_info'
	let newUrl = location.origin + location.pathname
	console.log(newUrl);
	const weixinApiConfig = {
		url: '//xmt.www.mi.com/index.php',
		m: 'interface-weixin',
		gh: 'gh_f10ac97bb079',
		signkey: '@#$3^*9^#@(XD)5#@%)',
	  }
	jsonp(
		`//xmt.www.mi.com/index.php?m=interface-weixin&do=sdk_signature_info&public_id=gh_f10ac97bb079&url=${newUrl}&type=jsonp`,
		null,
		(err, data) => {
			if (err) {
				console.error(err.message);
			} else {
				console.log(data)
				if (data.code == 0) {
					wx.config({
						debug: false,
						appId: "wx8388fce6cb5c6eca",
						timestamp: data.data.timestamp,
						nonceStr: data.data.nonce_str,
						signature: data.data.signature,
						jsApiList: [
							"updateTimelineShareData",
							"updateAppMessageShareData",
						], //选择需要使用的接口如调用拍照或从手机相册中选图接口
					});
					wx.ready(function () {
						wx.updateTimelineShareData({
							title: "小米@你，开新年盲盒领隐藏惊喜",
							desc: "小米@你，开新年盲盒领隐藏惊喜。",
							link: publicUrl,
							imgUrl: `${publicUrl}/img/role2.jpg?djkjkd`,
							success: function () { },
							cancel: function () { },
						});
						//
						wx.updateAppMessageShareData({
							title: "小米邀你免费抽盲盒", //25字
							desc: "小米@你，开新年盲盒领隐藏惊喜。",
							link: publicUrl,
							imgUrl: `${publicUrl}/img/role2.jpg?djkjkd`,
							success: function () { },
							cancel: function () { },
						});
					});
				}
			}
		}
	);
}
function GetRequest() {  
	var url = location.search; //获取url中"?"符后的字串  
	var theRequest = new Object();  
	if (url.indexOf("?") != -1) {  
	   var str = url.substr(1);  
	   strs = str.split("&");  
	   for(var i = 0; i < strs.length; i ++) {  
		  theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);  
	   }  
	}  
	return theRequest;  
 }  
export default router